import { render } from "./StandardV2Layout.vue?vue&type=template&id=5be48032&scoped=true"
import script from "./StandardV2Layout.vue?vue&type=script&lang=js"
export * from "./StandardV2Layout.vue?vue&type=script&lang=js"

import "./StandardV2Layout.vue?vue&type=style&index=0&id=5be48032&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be48032"]])

export default __exports__